import React, { Fragment } from "react";
import {
  Box,
  Drawer,
  Typography,
  useTheme,
  Grid,
  Divider,
  List,
  ListItem,
  ListItemText,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import Lock from "./assests/lock.png";
import { LoadingButton } from "../../components";

const StyledDrawer = styled(Drawer)(() => ({
  "& .MuiDrawer-paper": {
    background: "transparent",
  },
}));

const ContentBox = styled(Box)(() => ({
  textAlign: "center",
  alignContent: "center",
  alignItems: "center",
  borderRadius: "12.5px 12.5px 0 0",
  height: "auto",
  background: "rgb(255, 255, 255)",
  padding: "0px 25px 30px 25px",
  width: "100%",
}));

const CameraStartPopUp = ({
  cameraStartPopUp,
  setCameraStartPopUp,
  startCamera,
  setStartRecording,
}) => {
  const theme = useTheme();

  return (
    <Fragment>
      <StyledDrawer
        anchor="bottom"
        open={cameraStartPopUp}
        onClose={() => setCameraStartPopUp(false)}
      >
        {/* Close Button */}
        <Grid
          container
          sx={{ background: "transparent", padding: "15px 15px" }}
        >
          <Grid
            item
            container
            justifyContent="end"
            onClick={() => setCameraStartPopUp(false)}
          >
            <CloseIcon
              sx={{
                fontSize: "35px",
                padding: "4px",
                color: "white",
                borderRadius: "50%",
                background: "#FFFFFF38",
                visibility: "hidden",
              }}
            />
          </Grid>
        </Grid>

        <ContentBox>
          <Grid
            container
            alignItems="flex-start"
            justifyContent="space-between"
            sx={{ padding: "10px 3%" }}
          >
            {/* Lock Icon */}
            <Grid item>
              <img
                src={Lock}
                style={{ width: "110px", height: "130px" }}
                alt="lock"
              />
            </Grid>

            {/* Close Button */}
            <Grid item>
              <IconButton
                onClick={() => setCameraStartPopUp(false)}
                sx={{
                  color: "#555",
                  background: "#f5f5f5",
                  "&:hover": { background: "#e0e0e0" },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          {/* <IconButton
            onClick={() => setCameraStartPopUp(false)}
            sx={{
              // position: "absolute",
              float: "right",
              top: 12,
              right: 12,
              color: "#555",
              background: "#ffffffff",
              "&:hover": { background: "#ffffffff" },
            }}
          >
            <CloseIcon />
          </IconButton> */}
          {/* Heading below */}
          <Typography
            variant="h5"
            fontWeight={900}
            textAlign="left"
            sx={{
              fontSize: {
                xs: "1.55rem",
                sm: "1.75rem",
                md: "1.95rem",
              },
              "-webkit-text-stroke-width": ".25px",
              fontWeight: "bold",
              padding: "0 3%",
            }}
          >
            Consent & Privacy Declaration
          </Typography>
          {/* Lock Icon & Heading */}
          {/* <Grid
            container
            direction="column"
            alignItems="left"
            justifyContent="left"
            sx={{ padding: "10px 3%" }}
          > */}
          {/* <img
              src={Lock}
              style={{ width: "110px", height: "130px" }}
              alt="lock"
            /> */}
          {/* <Typography
              variant="h5"
              fontWeight={900}
              textAlign="left"
              sx={{
                fontSize: {
                  xs: "1.55rem",
                  sm: "1.75rem",
                  md: "1.95rem",
                },
                "-webkit-text-stroke-width": ".25px",
                fontWeight: "bold",
              }}
            >
              Consent & Privacy Declaration
            </Typography>
          </Grid> */}

          {/* Consent & Privacy Declaration Section */}
          <Box sx={{ textAlign: "left", padding: "10px 3%" }}>
            {/* Title with dividers */}

            {/* Small preview */}
            <Typography
              variant="body2"
              sx={{ color: "#555", textAlign: "center", mb: 2 }}
            >
              We use your name & biometric data only for this event.
            </Typography>

            {/* Details */}
            <Typography variant="body2" sx={{ mb: 1 }}>
              To provide you with a smooth and secure entry experience at the
              event, we will use:
            </Typography>

            <List dense>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText
                  primary="• Your Name (to match your identity with your registration)"
                  primaryTypographyProps={{ fontWeight: 700 }}
                />
              </ListItem>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText
                  primary="• Your Biometric Data (face verification) (to enable seamless, contactless access)"
                  primaryTypographyProps={{ fontWeight: 700 }}
                />
              </ListItem>
            </List>

            <Typography variant="body2" sx={{ fontWeight: 700, mt: 1 }}>
              How we handle your data:
            </Typography>

            <List dense>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText primary="• Your information will be used only for this event’s verification and access process." />
              </ListItem>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText primary="• All personal and biometric data will remain with us only until the event concludes." />
              </ListItem>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText primary="• After the event, your data will no longer be stored on our systems and will remain only on your device." />
              </ListItem>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText primary="• We do not share your information with any third parties." />
              </ListItem>
            </List>

            <Typography variant="body2" sx={{ mt: 1 }}>
              By continuing, you confirm that you understand and consent to the
              use of your name and biometric data for access at this event,
              under the terms described above.
            </Typography>
          </Box>

          {/* Action Button */}
          <LoadingButton
            onClick={() => {
              startCamera();
              setStartRecording(true);
              setCameraStartPopUp(false);
            }}
            style={{
              width: "100%",
              marginTop: "20px",
              padding: "12px 16px",
              boxShadow: "none",
            }}
          >
            Okay, Got It
          </LoadingButton>
        </ContentBox>
      </StyledDrawer>
    </Fragment>
  );
};

export default CameraStartPopUp;
